export const FormField = ({ id, label, optional, error, children }) => (
  <div className="flex flex-col gap-2">
    <label htmlFor={id} className="flex items-baseline justify-between font-mono text-[11px] uppercase tracking-[0.16em] text-[#55554f]">
      {label}
      {optional && <span className="normal-case tracking-normal text-[#94948a]">optional</span>}
    </label>
    {children}
    {!optional && (
      <p
        id={`${id}-error`}
        className="-mt-1 min-h-[18px] text-[13px] leading-[18px] text-[#c2410c]"
        role={error ? "alert" : undefined}
        data-testid={error ? `${id}-error` : undefined}
      >
        {error}
      </p>
    )}
  </div>
);
